import { DateTime } from "luxon";
import * as Yup from "yup";

export const messages = {
  required: "Required",
};

export const string = Yup.string().max(255, "Must be less than 256 characters");
export const requiredString = string.required(messages.required);

export const text = Yup.string().max(
  10_000,
  "Must be less than 10,001 characters",
);
export const requiredText = text.required(messages.required);

export const date = Yup.string().test(
  "is-valid-date",
  "Please enter a valid date in MM / DD / YYYY format",
  (value) => {
    if (!value) return false;
    const dateTime = DateTime.fromFormat(value, "MM / dd / yyyy");
    return dateTime.isValid;
  },
);

export const optionalDate = Yup.string().test(
  "is-valid-date",
  "Invalid format, please use MM/DD/YYYY",
  (value) => {
    if (!value) return true;
    const dateTime = DateTime.fromFormat(value, "MM / dd / yyyy");
    return dateTime.isValid;
  },
);

const requiredDate = date
  .required(messages.required)
  .typeError("Invalid format, please use MM/DD/YYYY");

export const requiredOver18Date = requiredDate.test(
  "is-over-18",
  "You must be at least 18 years old to join Conceive",
  (value) => {
    if (!value) return false;
    const dateTime = DateTime.fromFormat(value, "MM / dd / yyyy");

    return dateTime.isValid && dateTime.diffNow("years").years < -18;
  },
);

export const phone = Yup.string().test(
  "is-valid-phone",
  "Phone number is not valid",
  (value) => {
    if (!value) return false;

    // Strip out non-digit characters
    const strippedValue = value.replace(/\D/g, "");

    // Check if the resulting string is a 10-digit number
    return /^\d{10}$/.test(strippedValue);
  },
);

export const requiredPhone = phone.required(messages.required);

export const conditionalPhone = Yup.string().test(
  "is-not-international",
  messages.required,
  function (value) {
    const { international } = this.parent;
    if (!international) {
      const strippedValue = value?.replace(/\D/g, "");

      return !!strippedValue && /^\d{10}$/.test(strippedValue);
    }

    return true; // If not international, phone is required
  },
);

export const zip = Yup.string().matches(
  // This pattern expects exactly 5 digits
  /^\d{5}$/,
  "Zip code is not valid",
);
export const requiredZip = zip.required(messages.required);

export const number = Yup.number();
export const requiredNumber = number.required(messages.required);

export const requiredArrayOfStrings = Yup.array()
  .min(1)
  .of(requiredString)
  .required(messages.required);
